module.exports = __webpack_public_path__ + "static/media/sign.f1363e1d.png";